import { IGeoExV4 } from '../../../repositories/demand/entities/geo/GeoExV4';
import { IPersonalLeadFormData } from '../../../store/personal_leads_form';

export const _getGeoObject = (override?: Partial<IGeoExV4>): IGeoExV4 => ({
  districtIds: [],
  houseIds: [],
  locationIds: [],
  highwayIds: [],
  streets: [],
  undergroundIds: [],
  ...override,
});

export const geoMapper = (location: IPersonalLeadFormData['location']['value']) => {
  if (!location) {
    return _getGeoObject();
  }

  const geo = _getGeoObject({
    locationIds: [location.id],
  });

  return geo;
};
